import { all, call, getContext, put, takeEvery } from 'redux-saga/effects';
import type { Action } from '../utils';
import type { IEmployeeBranch } from '../../api/domain/channelsuite/user-services/employee-master-data';
import type { IEmployee } from '../../api/domain/channelsuite/user-services/employee-master-data/employee';
import type { ITeam } from '../../api/domain/channelsuite/user-services/employee-master-data/team';
import type { EmployeeMasterDataApiService } from '../../api/services/user-services/employee-master-data-api-service';
import { logError } from '../logging-api/logging-api-actions';
import {
    fetchBranch,
    fetchBranchFailure,
    fetchBranchSuccess,
    fetchEmployees,
    fetchEmployeesFailure,
    fetchEmployeesSuccess,
    fetchTeam,
    fetchTeamFailure,
    fetchTeamSuccess,
} from './employee-master-data-actions';

function* handleFetchBranch(action: Action<string>) {
    const api: EmployeeMasterDataApiService = yield getContext('employeeMasterDataApiService');
    try {
        const branch: IEmployeeBranch = yield call([api, api.getBranchByExternalId], action.payload);
        yield put(fetchBranchSuccess(branch));
    } catch (error: unknown) {
        yield put(logError(`could not fetch branch with id ${action.payload}: ${error}`));
        yield put(fetchBranchFailure(error));
    }
}

function* handleFetchTeam(action: Action<string>) {
    const api: EmployeeMasterDataApiService = yield getContext('employeeMasterDataApiService');
    try {
        const team: ITeam = yield call([api, api.getTeamByExternalId], action.payload);
        yield put(fetchTeamSuccess(team));
    } catch (error: unknown) {
        yield put(logError(`could not fetch team with id ${action.payload}: ${error}`));
        yield put(fetchTeamFailure(error));
    }
}

function* handleFetchEmployees(action: Action<string[]>) {
    const api: EmployeeMasterDataApiService = yield getContext('employeeMasterDataApiService');
    try {
        const employees: IEmployee[] = yield call([api, api.getEmployeesByExternalIds], action.payload);
        yield put(fetchEmployeesSuccess(employees));
    } catch (error: unknown) {
        yield put(logError(`could not fetch employees with ids [${action.payload.join(',')}]: ${error}`));
        yield put(fetchEmployeesFailure());
    }
}

export function* employeeMasterDataSaga() {
    yield all([takeEvery(fetchTeam, handleFetchTeam), takeEvery(fetchBranch, handleFetchBranch), takeEvery(fetchEmployees, handleFetchEmployees)]);
}
